import React, { useState } from "react";
import Select, { components } from "react-select";
import axios from "axios";
// import { Formik, Form, FieldArray, Field } from "formik";
// import { NavLink } from "react-router-dom";
// import * as Yup from "yup";

import ENUMS from "../../utils/ENUMS.js";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import DropdownIcon from "../../assets/images/faq/btn/down_arrow.svg";
import { BASE_URL } from "../../config.json";

let SubmitValue = 0;
let dropdown_list = [];
export const customStyles = () => ({
  menu: (provided, state) => ({
    ...provided,
    border: "1px solid #e2e2e2",
    marginTop: "-0.2rem",
    background: "#fff",
    position: "absolute",
    zIndex: 2,
    borderRadius: "0 0 3rem 3rem",
    overflow: "hidden",
  }),

  control: (provided, state) => ({
    ...provided,
    background: "#13320C",
    padding: "1.5rem 0.5rem 1.5rem 4rem",
    borderRadius: state.menuIsOpen ? "3rem 3rem 0 0" : "4rem",
    fontFamily: "Jost",
    fontSize: "1.8rem",
    fontWeight: "600",
    border: 0,
    boxShadow: 0,
    color: "white",
  }),

  placeholder: (provided, state) => ({
    ...provided,
    color: "grey",
    fontFamily: "Jost",
    fontSize: "1.8rem",
    textTransform: "UpperCase",
    overflow: "hidden",
  }),

  option: (provided, state) => ({
    ...provided,
    color: "black",
    padding: "1.3rem 1.9rem 1.2rem",
    fontSize: "16px",
    fontWeight: "500",
    borderBottom: "1px solid #ccc",
  }),

  singleValue: (provided, state) => ({
    ...provided,
    color: "white",
  }),

  input: (provided, state) => ({
    ...provided,
    color: "white",
  }),

  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: "0 0.5rem",
  }),
});

export const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator
      style={{ padding: "0 !important" }}
      {...props}
    >
      <img style={{ marginLeft: "0.5rem", width: "3rem" }} src={DropdownIcon} />
    </components.DropdownIndicator>
  );
};

const GolfCourses = () => {
  const token = localStorage.getItem(ENUMS.AUTH);
  const userTemplate = { course_name: "", number_of_holes: "" };
  const [users, setUsers] = useState([userTemplate]);
  const [Holes, SetHoles] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [selectedHolesNo, setSelectedHolesNo] = useState([]);

  const addUser = () => {
    setUsers([...users, userTemplate]);
  };
  const onChange = (e, index) => {
    const updatedUsers = users.map((user, i) =>
      index == i
        ? Object.assign(user, { [e.target.name]: e.target.value })
        : user
    );
    console.log(updatedUsers, "users");
    setUsers(updatedUsers);
  };
  const PopulateCourseFromLocalStorage = () => {
    if (localStorage.getItem("Create-GolfCourse")) {
      const savedUsers = JSON.parse(localStorage.getItem("Create-GolfCourse"));
      setUsers(savedUsers);
    }
  };
  useEffect(() => {
    PopulateCourseFromLocalStorage();
    // checkClubDetailsRemoveLocalStorageItem();
  }, []);
  const HolesDropdown = () => {
    const config = {
      // headers: { Authorization: `Bearer ${token}` }
    };

    axios
      .get(`${BASE_URL}/club/get_course_holes/`, config)
      .then((res) => {
        console.log(res, "DROPDWON");
        // console.log(res,"harry")
        SetHoles(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  let history = useHistory();

  const storeGolfCourseInLocalStorage = (values) =>
    localStorage.setItem("Create-GolfCourse", JSON.stringify(values));

  const checkGolfCourseRemoveLocalStorageItem = () =>
    localStorage.getItem("Create-GolfCourse") &&
    localStorage.removeItem("Create-GolfCourse");
  const onSubmit = () => {
    setSubmit(true);

    users.forEach((element, index) => {
      if (element.course_name != "") {
        //  setSubmit(1);
        SubmitValue = 1;
        console.log(element.course_name);
      } else {
        SubmitValue = 0;
      }
    });

    if (SubmitValue == 1) {
      history.push({ pathname: "/golf-pay", state: { users: users } });
      storeGolfCourseInLocalStorage(users);
    }
  };

  useEffect(() => {
    HolesDropdown();
  }, []);
  const removeUser = (index) => {
    const filteredUsers = [...users];
    filteredUsers.splice(index, 1);
    setUsers(filteredUsers);
  };

  return (
    <section className=" club_Login">
      <div className="page-width">
        <div className="gCourses-block">
          <h1 className="login-title text-jost-sb-50">
            Sign up your club today
          </h1>

          <div className="gCourses__wrap_parts">
            {/* <div className="gCourses__bar">
              <ul className="gCourses__bar__row">
                <li className="text-jost-sb-22 completed">CLUB Details</li>
                <li className="text-jost-sb-22 active ">Golf Courses</li>
                <li className="text-jost-sb-22">Payment DETAILS</li>
                <li className="text-jost-sb-22">Confirmation</li>
              </ul>
            </div> */}
            <div className="progress_bar">
              <ul className="progress_bar__row ">
                <li className="text-jost-sb-22 completed">CLUB Details</li>
                <li className="text-jost-sb-22 active">Golf Courses</li>
                <li className="text-jost-sb-22">Payment DETAILS</li>
                <li className="text-jost-sb-22">Confirmation</li>
              </ul>
            </div>

            <h2 className="text-jost-sb-22">
              How many Golf Courses do you have?
            </h2>
            <div className="gCourses__box">
              {users.map((user, index) => {
                console.log(user, "user");
                return (
                  <div key={index} className="acccore__box__sec2">
                    <div className="acccore__box__sec2__cdiv">
                      <input
                        className="acc__input-ex-lg"
                        type="text"
                        placeholder="Course Name"
                        name="course_name"
                        onChange={(e) => onChange(e, index)}
                        value={users[index].course_name}
                      />

                      {submit &&
                        (users[index].course_name == "" ? (
                          <div style={{ color: "red" }}>* Required</div>
                        ) : null)}
                    </div>

                    <div className="custom-select-wrapper">
                      <Select
                        options={Holes.map((hole) => {
                          return {
                            id: hole.id,
                            label: hole.total_holes,
                            value: hole.total_holes,
                            target: {
                              name: "number_of_holes",
                              value: hole.total_holes,
                            },
                          };
                        })}
                        name="number_of_holes"
                        isClearable={false}
                        onChange={(e) => onChange(e, index)}
                        components={{ DropdownIndicator }}
                        value={
                          user.number_of_holes === ""
                            ? []
                            : {
                                label: user.number_of_holes,
                                value: user.number_of_holes,
                              }
                        }
                        styles={customStyles()}
                        isSearchable={false}
                        placeholder="Select Holes*"
                        loading={false}
                      />

                      {submit &&
                        (users[index].number_of_holes == "" ? (
                          <div className="errors" style={{ color: "red" }}>
                            * Please select valid Holes
                          </div>
                        ) : null)}

                      {/* {formik.touched['country'] && (formik.errors.country ?
                                        <div className='errors' style={{color: 'red'}}>* {formik.errors.country}</div> : null)} */}

                      {/* <div style={{padding: "0 2rem 0 0"}} className="custom-select acc__input-lg">
                                            <div>
                                                <select style={{cursor: "pointer"}} name="number_of_holes" className="acc__input-lg"
                                                        onChange={e => onChange(e, index)}
                                                        value={users[index].number_of_holes}
                                                        components={{LoadingIndicator: null}}>
                                                    <option value="" disabled selected>SELECT NO OF HOLES</option>
                                                    <option value='1'>{'9'}</option>
                                                    <option value='2'>{'18'}</option>

                                                </select>

                                                <div className="dropdown-btn-mod"></div>
                                            </div>



                                        </div> */}
                    </div>

                    {
                      <div className="golf_course_btns">
                        <button onClick={addUser}>
                          <img
                            src={
                              require("../../assets/images/btn/plus_btn.svg")
                                .default
                            }
                            alt=""
                          />
                        </button>

                        {users.length > 1 ? (
                          <button
                            style={{ backgroundColor: "white" }}
                            onClick={() => removeUser(index)}
                          >
                            <img
                              src={
                                require("../../assets/images/del/delete.svg")
                                  .default
                              }
                              alt=""
                            />
                          </button>
                        ) : null}
                      </div>
                    }
                  </div>
                );
              })}
            </div>
            <div className="gCourses-links">
              <button
                className="res-btn-ternary"
                onClick={(event) => {
                  history.push({ pathname: "/club-detail" });
                }}
              >
                Back
              </button>
              <button className="res-btn-primary" onClick={onSubmit}>
                Save & continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GolfCourses;
